import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Result, Button } from 'antd';

import './style.css';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Result
      status='404'
      title={t('not_found_page.title')}
      subTitle={t('not_found_page.message')}
      extra={
        <Button type='primary' onClick={() => navigate('/')}>
          {t('not_found_page.back_home')}
        </Button>
      }
      style={{ marginTop: '5%' }}
    />
  );
};

export default NotFoundPage;
